import { StyleSheet } from "react-native";
import { appColors, appFonts, fontSize } from "../../appTheme";

export const TipSettingsStyle = StyleSheet.create({
    containerStyle: {
        flex: 1,
        backgroundColor: appColors?.lightBackgroundColor
    },
    loaderStyle: {
        flex: 1, alignItems: 'center', justifyContent: 'center'
    },
    buttonView: {
        flexDirection: 'row', alignSelf: 'flex-end', marginTop: 15
    },
    tipView: {
        flexDirection: 'row', justifyContent: 'space-between'
    },
    toolTipView: {
        marginLeft: 10, marginTop: -2
    },
    buttonStyle: {
        width: 100, borderRadius: 7
    },
    titleStyle: {
        fontFamily: appFonts.bold, fontSize: fontSize.smallerFontSize
    }
})